
import { Vue, Component } from "vue-property-decorator";
import TextInput from "@/components/Reusable/CustomInputs/TextInput.vue";
import DropdownInput from "@/components/Reusable/CustomInputs/DropdownInput.vue";
import IconButton from "@/components/UI/IconButton.vue";
import NumberInput from "@/components/Reusable/CustomInputs/NumberInput.vue";
import { saveGlobalBlockSettings } from "@/lib/global-blocks/global-blocks";
import { configStore, documentStore } from "@/store/store-accessor";
import defensiveCopy from "@/util/defensive-copy";
import lodash from "lodash";
import { breakdanceUndo } from "@/lib/undo/undo";

@Component({
  components: {
    TextInput,
    IconButton,
    NumberInput,
    DropdownInput
  }
})
export default class PreviewChooserSettings extends Vue {
  dropdownOptions = {
    populate: {
      path: "",
      text: "",
      value: "",
      fetchDataAction: "breakdance_fetch_flexible_content_fields",
      fetchContextPath: "",
      refetchPaths: []
    }
  };

  get postId() {
    return documentStore.document.documentMeta.id;
  }

  get blockSettings() {
    const settings = documentStore.document.documentMeta.blockSettings;

    if (!settings) {
      return {
        preview: {
          acfFlexibleField: "",
          acfFlexibleFieldRow: undefined
        }
      };
    }

    return settings;
  }

  async saveSettings() {
    await saveGlobalBlockSettings(this.postId, this.blockSettings);
    configStore.flushDynamicDataCache();
  }

  setFlexibleField(acfFlexibleField: string | undefined) {
    const documentMeta = defensiveCopy(documentStore.document.documentMeta);

    lodash.set(
      documentMeta,
      "blockSettings.preview.acfFlexibleField",
      acfFlexibleField
    );

    breakdanceUndo.ignore(() => {
      documentStore.setDocumentMeta(documentMeta);
      this.saveSettings();
    });
  }

  setRowIndex(acfFlexibleFieldRow: number | undefined) {
    const documentMeta = defensiveCopy(documentStore.document.documentMeta);

    lodash.set(
      documentMeta,
      "blockSettings.preview.acfFlexibleFieldRow",
      acfFlexibleFieldRow
    );

    breakdanceUndo.ignore(() => {
      documentStore.setDocumentMeta(documentMeta);
      this.saveSettings();
    });
  }
}
